// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"206":"2e612d8b","617":"79c2f874"}[chunkId] + ".js";
};